module.exports = __webpack_public_path__ + "static/img/2w_onlinepayment.cf5d11b.jpg";